import React, { useContext } from 'react';
import { TITLE } from '../../constant';
import { Button, Card, CardBody, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import OrgContext from '../../context/OrgContext/OrgContext';

const DonationConfirmation = (props) => {
  const { onSubmit, close } = props;
  const { donationConfirmation } = useContext(OrgContext);
  return (
    <Modal size="md" isOpen={donationConfirmation} toggle={() => close()}>
      <ModalHeader toggle={() => close()}>
        <span>{TITLE.CONFIRMATION}</span>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <Form className="needs-validation">
                  <Row>Are you sure you don't want to add a mobile number?</Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onSubmit}>
          Yes
        </Button>{' '}
        <Button color="secondary" onClick={close}>
          No
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DonationConfirmation;
